import { createChessboard } from '../../utils';
import { preAssessmentBoard1, preAssessmentBoard2 } from './assignments';

let lessonConfig = [
    {
        id: 0,
        previous: null,
        next: null,
        video: {
            src: 'img/videos/pre-assessment/1.mp4',
            startTime: 0,
            autoStartNext: true,
            next: 1
        }
    },
    {
        id: 1,
        previous: 0,
        next: 2,
        qa: {
            id: 1,
            isAssessment: true,
            question: 'How do you find a coordinate?',
            answer: [
                'Draw a line to connect the stars',
                'Go up a file and across a rank to meet',
                'You need to use paper and scissors',
                'I don’t know'
            ],
            rightAnswer: 'Go up a file and across a rank to meet',
            validateAnswer: { rightAnswer: 1, userAnswer: -1 },
            styleClass: 'md',
            chessboard: {
                board: preAssessmentBoard1({
                    showIndicators: true,
                    squares: ['.square-c2', '.square-e6', '.square-g2'],
                }),
                hint: true
            },
        }
    },
    {
        id: 2,
        previous: 1,
        next: 3,
        qa: {
            id: 2,
            isAssessment: true,
            question: 'What does analyze mean?',
            answer: [
                'It doesn\'t matter',
                'Take turns',
                'Weigh your options',
                'I don\'t know'
            ],
            rightAnswer: 'Weigh your options',
            validateAnswer: { rightAnswer: 2, userAnswer: -1 },
            styleClass: 'md',
        }
    },
    {
        id: 3,
        previous: 2,
        next: 4,
        qa: {
            id: 3,
            isAssessment: true,
            question: 'Solve the equation: <b>__R + __P = Q',
            answer: [
                '1R + 4p = Q',
                '2R + 1p = Q',
                '2R + 5p = Q',
                'I don\'t know'
            ],
            rightAnswer: '8',
            validateAnswer: { rightAnswer: 0, userAnswer: -1 },
            styleClass: 'md'
        }
    },
    {
        id: 4,
        previous: 3,
        next: 5,
        qa: {
            id: 4,
            isAssessment: true,
            question: 'The Knight jumps to f2. How many moves will it take for the Knight to capture all eight pawns?',
            answer: [
                '8',
                '12',
                '16',
                'I don\'t know'
            ],
            rightAnswer: '8',
            validateAnswer: { rightAnswer: 0, userAnswer: -1 },
            styleClass: 'md',
            chessboard: {
                board: createChessboard({
                    showIndicators: true,
                    position: '8/8/8/3PPP2/3PnP2/3PPP2/8/8',
                    assignmentClass: 'custom-sparepiece',
                }),
                canvas: {
                    from: 'square-e4',
                    to: 'square-f2'
                },
                hint: true
            }
        }
    },
    {
        id: 5,
        previous: 4,
        next: 6,
        qa: {
            id: 5,
            isAssessment: true,
            question: 'Analyze the board to determine which team (black or white) has the advantage and why?',
            answer: [
                'White is one move from checkmate',
                'Black is one move from checkmate',
                'Black and White are tied',
                'I don\'t know'
            ],
            rightAnswer: 'Black is one move from checkmate',
            validateAnswer: { rightAnswer: 1, userAnswer: -1 },
            styleClass: 'md',
            chessboard: {
                board: createChessboard({
                    showIndicators: true,
                    position: '5r2/pkp3r1/1p6/8/8/2N2P2/PPP2P2/5RK1'
                }),
                hint: true
            }
        }
    },
    {
        id: 6,
        previous: 5,
        next: 7,
        qa: {
            id: 6,
            isAssessment: true,
            question: 'Add one piece to this board so White will have checkmate.',
            answer: [
                'White Rook on e7',
                'White Knight on b6',
                'White Bishop on e4',
                'I don\'t know'
            ],
            rightAnswer: 'White Knight on b6',
            validateAnswer: { rightAnswer: 1, userAnswer: -1 },
            styleClass: 'md',
            chessboard: {
                board: createChessboard({
                    showIndicators: true,
                    position: 'kb6/r7/2K5/8/8/8/8/8'
                }),
                hint: true
            }
        }
    },
    {
        id: 7,
        previous: 6,
        next: 8,
        qa: {
            id: 7,
            isAssessment: true,
            question: 'Which team is stronger?',
            answer: [
                'Team A: King, two Rooks, and 4 pawns',
                'Team B: King, Knight, two Bishops and a pawn',
                'Team C: King, Knight, Bishop and 4 pawns',
                'I don\'t know'
            ],
            rightAnswer: 'Team A: King, two Rooks, and 4 pawns',
            validateAnswer: { rightAnswer: 0, userAnswer: -1 },
            styleClass: 'md'
        }
    },
    {
        id: 8,
        previous: 7,
        next: 9,
        qa: {
            id: 8,
            isAssessment: true,
            question: 'How many black squares are missing from this board?',
            answer: [
                '2',
                '5',
                '10',
                'I don\'t know'
            ],
            rightAnswer: '5',
            validateAnswer: { rightAnswer: 1, userAnswer: -1 },
            styleClass: 'md',
            chessboard: {
                board: preAssessmentBoard2({
                    showIndicators: true,
                    squares: ['.square-d6', '.square-f6', '.square-e5', '.square-d4', '.square-f4']
                }),
                hint: true
            }
        }
    },
    {
        id: 9,
        previous: 8,
        next: 10,
        qa: {
            id: 9,
            isAssessment: true,
            question: 'Why are diagonal lines special?',
            answer: [
                'They alternate dark and light squares',
                'They have the most squares',
                'They are only one color',
                'I don\'t know'
            ],
            rightAnswer: 'They are only one color',
            validateAnswer: { rightAnswer: 2, userAnswer: -1 },
            styleClass: 'md'
        }
    },
    {
        id: 10,
        previous: 9,
        next: 11,
        qa: {
            id: 10,
            isAssessment: true,
            question: 'What is the best move?',
            answer: [
                'Check',
                'Checkmate',
                'Stalemate',
                'I don\'t know'
            ],
            rightAnswer: 'Checkmate',
            validateAnswer: { rightAnswer: 1, userAnswer: -1 },
            styleClass: 'md'
        }
    },
    {
        id: 11,
        previous: 0,
        next: null,
        audio: { src: null, stop: true },
        text: {
            data: 'You are done!<br>Don\'t worry if you didn\'t<br>know all the answers, that\'s<br>what you will be learning.',
            position: 'center',
            styleClass: 'xxl'
        },
        qa: {
            position: 'center',
            nextLesson: 'Lesson One',
            result: true,
            isPreAssessment: true,
            styleClass: 'xxl',
        }
    },
];

let assets = [
    'img/background_0.png'
];

let config = {
    assets: assets,
    config: lessonConfig
};

export default config;



// WEBPACK FOOTER //
// ./src/lessons/pre-assessment/index.js